import React, { FunctionComponent, ReactNode } from "react";
import { Link } from "gatsby";
import styled, { ThemeProvider } from "styled-components";
import { defaultTheme } from "../../theme";
import { FluidObject } from "gatsby-image";
import Img from "gatsby-image";

interface ArticleWidgetProps {
    title: string
    imageFluid?: FluidObject
    description: string
    link: string
    tags: readonly string[]
    category?: string
    date: string
}

const Wrapper = styled.div`
  border-radius: ${props => props.theme.defaultBorderRadius};
  background-color: ${props => props.theme.colors.altBackground};
  overflow: hidden;
  border: darkgray 1px solid;
  //box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: translateY(-3px);
  }

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
    width: 90vw;
    //width: calc(600px * 0.8);

  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    width: 90vw;
    //width: calc(600px * 0.8);

  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    width: calc(600px * 0.8);

  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    width: calc(600px * 0.8);

  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    width: 600px;

  }
`;

const ImageWrapper = styled.div`
  // crops from the bottom
  max-height: 360px;
  overflow: hidden;


`;

const Bottom = styled.div`
  padding: 25px;
`;

const Category = styled.div`
  background-color: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.primary};
  display: inline-block;
  border-radius: 5px;
  padding: 3px 20px;
  margin-bottom: 25px;
  font-size: smaller;
`;

const AlternateImage = styled.img`
  margin: 0;
`;


const ArticleWidget: FunctionComponent<ArticleWidgetProps> = ({
                                                                  title,
                                                                  description,
                                                                  imageFluid,
                                                                  link,
                                                                  category,
                                                                  date,
                                                              }) => {

    return (
        <ThemeProvider theme={defaultTheme}>
            <Link to={link}>
                <Wrapper>
                    <ImageWrapper>
                        {imageFluid && <Img fluid={imageFluid} />}
                    </ImageWrapper>
                    <Bottom>
                        <Category>
                            {category}
                        </Category>
                        <h3>{title}</h3>
                        <p>{description}</p>
                        {new Date(date).toLocaleDateString("pl-PL", { day: "numeric", month: "long", year: "numeric" })}
                    </Bottom>
                </Wrapper>
            </Link>
        </ThemeProvider>
    );
};

export default ArticleWidget;
